module.exports = __webpack_public_path__ + "img/5.a13dd9cf.jpg";